var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"categories"},[_c('h5',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t("categories-and-keywords")))]),_c('FormGenerator',_vm._b({attrs:{"elements":_vm.elements,"handleUpdate":_vm.handleUpdate,"data":_vm.book,"inline":""}},'FormGenerator',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }